import React from 'react'
import { Button } from '../../common/button'
import './styles.scss'
import { useSelector } from 'react-redux'
import { getUpsellPrice } from '../../../redux/slices/configSlice'

const Footer = ({ onUpgradeBtnClick, onSkipBtnClick }) => {
	const upsellPrice = useSelector(getUpsellPrice)

	return (
		<div className="upsell-footer">
			<div className="upsell-footer__info">
				<span>USD {upsellPrice === 999 ? '19.99' : '9.99'}</span> USD{' '}
				{upsellPrice / 100} will be added to your order
			</div>
			<Button buttonText={'Upgrade My Order'} onClick={onUpgradeBtnClick} />
			<button className="upsell-footer__skip" onClick={onSkipBtnClick}>
				No, thank you
			</button>
		</div>
	)
}

export { Footer }
